import ReactDOM from "react-dom";
import ApolloProvider from "./Apollo/ApolloProvider";

ReactDOM.render(ApolloProvider, document.getElementById("root"));
